import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "../views/Layout.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    meta: {
      title: '主布局'
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router


